import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { UserType } from '../../_models';
import { List } from 'linqts';
import { query } from '@angular/animations';



interface Class{
  id:number,
  name :string
}


interface Department{
  id:number,
  name :string
}


interface Employee{
  id:number,
  name :string,
  departmentId: number
}

interface Sections{
  id:number,
  name :string,
  classId:number
}

interface Student{
  id:number,
  name :string,
  sectionId: number
}


@Injectable({
  providedIn: 'root'
})
export class ClassSectionDepartmentService {

  constructor() {}
  
   getClass() : List<Class> {
   let l = new  List<Class> ( [
      {id:1,name:"Class 1"},
      {id:2,name:"Class 2"},
      {id:3,name:"Class 3"},
      {id:4,name:"Class 4"},
      {id:5,name:"Class 5"},
      {id:6,name:"Class 6"},
      {id:7,name:"Class 7"},
      {id:8,name:"Class 8"} ,  
      {id:9,name:"Class 9"},
      {id:10,name:"Class 10"},
      {id:11,name:"Class 11"},
      {id:12,name:"Class 12"}
    ]);

    return l;
  }
  getSections()  : List<Sections>{
    
    let l = new  List<Sections> (  [
      {id:1,name:"Sections 1", classId :1},
      {id:2,name:"Sections 2", classId :1},
      {id:3,name:"Sections 3" , classId :1},
      {id:4,name:"Sections 1", classId :2},
      {id:5,name:"Sections 2", classId :2},
      {id:6,name:"Sections 3" , classId :2},
      {id:7,name:"Sections 1", classId :3},
      {id:8,name:"Sections 2", classId :3},
      {id:9,name:"Sections 3" , classId :3},
      {id:10,name:"Sections 1", classId :4},
      {id:11,name:"Sections 2", classId :4},
      {id:12,name:"Sections 3" , classId :4},
      {id:13,name:"Sections 1", classId :5},
      {id:14,name:"Sections 2", classId :5},
      {id:15,name:"Sections 3" , classId :5},
      {id:16,name:"Sections 1", classId :6},
      {id:17,name:"Sections 2", classId :6},
      {id:18,name:"Sections 3" , classId :6},
    ]);

    return l;
  }

  getStudent(sectionId) : Student[]{

    const student :List<Student> =new List ([
      {id:1,name:"Alaa Abbas ALtair", sectionId :1},
      {id:2,name:"Ahmad Ali Mohammad", sectionId :1},
      {id:3,name:"Samer ahmad Mohammad" , sectionId :1},
      {id:4,name:"Ramy mohammad Duke", sectionId :2},
      {id:5,name:"Muna Ahamd Ali", sectionId :2},
      {id:6,name:"Ahmamd Ali Shamanah" , sectionId :2},
      {id:7,name:"ali Sami Mohamad", sectionId :3},
      {id:8,name:"Aamih Faisal Abdlqader", sectionId :3},
      {id:9,name:"liath Ahmad Aalamh" , sectionId :3},
      {id:10,name:"Ahmad Ali daly", sectionId :4},
      {id:11,name:"Mohmoud Ahmad Alnatore", sectionId :4},
      {id:12,name:"Malk mohammad Alhazen" , sectionId :4},
      {id:13,name:"Abbas Alaa Altair", sectionId :5},
      {id:14,name:"Alaa Mohammad Younise", sectionId :5},
      {id:15,name:"ali ahmad ali" , sectionId :5},
      {id:16,name:"Ahmad Ali Ahmad", sectionId :6},
      {id:17,name:"Sami Ali Sami", sectionId :6},
      {id:18,name:"Ali Sami Ali" , sectionId :6},
    ]);



    return student.Where(stu => stu.sectionId== sectionId).ToArray();
  }

  getClassSection() {

    let  c = this.getClass();
    let s = this.getSections();
    var query = s // your starting point - table in the "from" statement
    .Join(c, // the source table of the inner join
       section => section.classId,        // Select the primary key (the first part of the "on" clause in an sql "join" statement)
       classs => classs.id,   // Select the foreign key (the second part of the "on" clause)
       (section, classs)  => ({id: section.id ,classId:classs.id , name :classs.name +" - "+section.name })); // selection    
    
       return query.ToArray();
   }

  
   getDepartment() :Department[] {
    let l = new  List<Department> ( [
       {id:1,name:"Department 1"},
       {id:2,name:"Department 2"},
       {id:3,name:"Department 3"},
       {id:4,name:"Department 4"},
       {id:5,name:"Department 5"},
       {id:6,name:"Department 6"},
       {id:7,name:"Department 7"},
       {id:8,name:"Department 8"} ,  
       {id:9,name:"Department 9"},
       {id:10,name:"Department 10"},
       {id:11,name:"Department 11"},
       {id:12,name:"Department 12"}
     ]);
 
     return l.ToArray();
   }

   getEmployee(departmentId) : Employee[]{

    const Employee :List<Employee> =new List ([
      {id:1,name:"Alaa Abbas ALtair", departmentId :1},
      {id:2,name:"Ahmad Ali Mohammad", departmentId :1},
      {id:3,name:"Samer ahmad Mohammad" , departmentId :1},
      {id:4,name:"Ramy mohammad Duke", departmentId :2},
      {id:5,name:"Muna Ahamd Ali", departmentId :2},
      {id:6,name:"Ahmamd Ali Shamanah" , departmentId :2},
      {id:7,name:"ali Sami Mohamad", departmentId :3},
      {id:8,name:"Aamih Faisal Abdlqader", departmentId :3},
      {id:9,name:"liath Ahmad Aalamh" , departmentId :3},
      {id:10,name:"Ahmad Ali daly", departmentId :4},
      {id:11,name:"Mohmoud Ahmad Alnatore", departmentId :4},
      {id:12,name:"Malk mohammad Alhazen" , departmentId :4},
      {id:13,name:"Abbas Alaa Altair", departmentId :5},
      {id:14,name:"Alaa Mohammad Younise", departmentId :5},
      {id:15,name:"ali ahmad ali" , departmentId :5},
      {id:16,name:"Ahmad Ali Ahmad", departmentId :6},
      {id:17,name:"Sami Ali Sami", departmentId :6},
      {id:18,name:"Ali Sami Ali" , departmentId :6},
    ]);



    return Employee.Where(stu => stu.departmentId== departmentId).ToArray();
  }
   



  


}


